import { AdsDropdownDivider } from '../ads-dropdown-divider/ads-dropdown-divider';
import { AdsDropdownItem } from '../ads-dropdown-item/ads-dropdown-item';
import {
  DropdownBlurEvent,
  DropdownBlurHandler,
  DropdownChangeEvent,
  DropdownChangeHandler,
  DropdownFocusEvent,
  DropdownFocusHandler,
  DropdownItemTypes,
  DropdownOption,
  DropdownOptionGroup,
} from './../../ads-dropdown.types';
import { EventEmitter, FunctionalComponent, VNode, h } from '@stencil/core';
import { Icon, SVGIcon, SVGIconData, getIconObject, getSVGIconObject } from '../../../core/interfaces/Icon';
import { generateSVGImage, isNullOrUndefined } from 'utils/index';

interface AdsDropdownGroupProps {
  group: DropdownOptionGroup;
  dropdownBlur?: EventEmitter<DropdownBlurEvent>;
  dropdownChange?: EventEmitter<DropdownChangeEvent>;
  dropdownFocus?: EventEmitter<DropdownFocusEvent>;
  dropdownBlurHandler?: DropdownBlurHandler;
  dropdownChangeHandler?: DropdownChangeHandler;
  dropdownFocusHandler?: DropdownFocusHandler;
}

export const AdsDropdownGroup: FunctionalComponent<AdsDropdownGroupProps> = ({
  group,
  dropdownBlur,
  dropdownBlurHandler,
  dropdownChange,
  dropdownChangeHandler,
  dropdownFocus,
  dropdownFocusHandler,
}) => {
  const attributes = {
    disabled: group.disabled ? true : null,
  };

  let svgIcon: SVGIconData = undefined;
  let classIcon: string = undefined;
  const svgIconObj = getSVGIconObject(group.icon as SVGIcon);
  svgIcon = svgIconObj?.active;
  const iconObj = getIconObject(group.icon as Icon);
  classIcon = iconObj?.active;

  const groupClasses = ['c-dropdown__group'];

  if (group.disabled) {
    groupClasses.push('is-disabled');
  }

  return (
    <div part="group" class={groupClasses.join(' ')}>
      <span class="c-dropdown__group__item" {...attributes}>
        {(classIcon || svgIcon) && (
          <span class="c-dropdown__group__item__icon">
            <span class={classIcon && classIcon}>
              {!isNullOrUndefined(svgIcon) && generateSVGImage({ data: svgIcon.data, height: svgIcon.height, width: svgIcon.width })}
            </span>
          </span>
        )}
        <span part="group-label" class="c-dropdown__group__item__label">
          {group.text}
        </span>
      </span>
      {!isNullOrUndefined(group.items) && Array.isArray(group.items)
        ? group.items.map((option) => {
            switch (option.type) {
              case DropdownItemTypes.DIVIDER:
                return (<AdsDropdownDivider />) as VNode;
              case DropdownItemTypes.ACTION:
              default: {
                return (
                  <AdsDropdownItem
                    item={{ ...option, disabled: group.disabled ? true : (option as DropdownOption).disabled } as DropdownOption}
                    dropdownBlur={dropdownBlur}
                    dropdownChange={dropdownChange}
                    dropdownFocus={dropdownFocus}
                    dropdownBlurHandler={dropdownBlurHandler}
                    dropdownChangeHandler={dropdownChangeHandler}
                    dropdownFocusHandler={dropdownFocusHandler}
                  />
                ) as VNode;
              }
            }
          })
        : null}
    </div>
  ) as VNode;
};
